<template>
  <section class="intro-container">
    <div class="background" />
    <div class="content">
      <h1 class="title">
        Документы и&nbsp;таблицы без ограничений&nbsp;&mdash; как Google, но&nbsp;быстрее и&nbsp;без блокировок
      </h1>
      <p class="text">
        Управляйте процессами, создавая и&nbsp;редактируя текстовые и&nbsp;табличные документы онлайн&nbsp;&mdash; исключив риски блокировки Google Sheets и&nbsp;Docs.
      </p>
      <p class="text-mobile">
        Управляйте процессами, создавая и&nbsp;редактируя текстовые и&nbsp;табличные документы онлайн&nbsp;&mdash; исключив риски блокировки Google Sheets и&nbsp;Docs.
      </p>
      <a target="_blank" :href="signupUrl" class="ui-button-primary mod_rounded-size-s button">
        Начать бесплатно
        <inline-svg src="/images/v4/svg/back.svg" />
      </a>
    </div>
    <intro-slider />
    <intro-features />
  </section>
</template>

<script>
import IntroSlider from "@/components/main/partials/intro/IntroSlider.vue";
import IntroFeatures from "@/components/main/partials/intro/IntroFeatures.vue";

export default {
  name: 'Intro',
  components: {
    IntroSlider,
    IntroFeatures,
  },
}
</script>

<style scoped lang="scss">
@import "@/styles/breakpoints";
@import "@/styles/button-primary.scss";

.intro-container {
  position: relative;
  max-width: 1220px;
  margin: 0 auto 90px;
  padding: 138px 20px 0;

  .background {
    background-image: url('../../../../../public/images/v4/images/image-dots@2x.webp'), url('../../../../../public/images/v4/images/image-header-bg@2x.webp');
    background-size: 1398px 705px, 100%;
    background-repeat: no-repeat, no-repeat;
    background-position: center top 103px, center bottom;
    max-width: 1180px;
    padding: 70px 17px 0;
    height: 878px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    position: absolute;
    top: 0;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    display: block;
  }

  .content {
    z-index: 2;
    position: relative;
    margin: 0 auto;
    max-width: 750px;
    text-align: center;
  }

  .title {
    font-size: 44px;
    font-weight: 700;
    line-height: 51px;
    margin-bottom: 21px;
  }

  .text {
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    margin: 0 0 25px;
  }

  .text-mobile {
    display: none;
  }

  .button {
    max-width: 293px;
    box-shadow: 0 2px 6px 0 rgba(60, 44, 20, 0.48);
    line-height: 27px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 75px;
    gap: 12px;

    svg {
      width: 20px;
      height: 21px;
      fill: #fff;
    }
  }
}

@include media-breakpoint-down($size-desktop) {
  //
}

@include media-breakpoint-down($size-tablet) {
  .intro-container {
    padding: 118px 0 0;
    margin: 0 auto 69px;

    .background {
      height: 626px;
    }

    .content {
      padding: 0 34px;
      max-width: unset;
    }

    .title {
      line-height: 52px;
      margin: 0 auto 20px;
    }

    .button {
      margin-bottom: 55px;
    }
  }
}

@include media-breakpoint-down($size-mobile) {
  .intro-container {
    margin: 0 auto 45px;
    padding: 77px 0 0;

    .background {
      height: 566px;
    }

    .content {
      padding: 0 20px;
    }

    .title {
      padding: 0 10px;
      font-size: 21px;
      line-height: 28px;
      margin: 0 auto 15px;
    }

    .text {
      display: none;
    }

    .text-mobile {
      display: block;
      font-size: 15px;
      font-weight: 400;
      line-height: 24px;
      margin: 0 auto 20px;
    }

    .button {
      max-width: 240px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-bottom: 50px;
    }
  }
}
</style>
